import type { LlmConversationPromptOptions } from '../llm/llm-input-types';
import type { Message as MessageClass } from './message';
import type { WorkspaceDomainLoader } from './workspace-prefetch';

/** Chat-layer prompt options; assignable to {@link LlmConversationPromptOptions} on the builder. */
export type ConversationPromptOptions = Omit<
  LlmConversationPromptOptions,
  'workspaceDomainLoader' | 'prune'
> & {
  workspaceDomainLoader: WorkspaceDomainLoader | undefined;
  prune?: (message: MessageClass, index: number) => boolean;
};

/** Narrow {@link LlmPromptMessage} prune callbacks to {@link MessageClass}. */
export const toLlmConversationPromptOptions = (
  options: ConversationPromptOptions
): LlmConversationPromptOptions => ({
  workspaceDomainLoader: options.workspaceDomainLoader,
  prune:
    options.prune !== undefined
      ? (message, index) => options.prune!(message as MessageClass, index)
      : undefined,
  participantContext: options.participantContext,
});
